import React, { useMemo } from "react";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import colors from "common/styles/colors";
import { ComparableMarker } from "../../../components/map/ComparableMarker";
import { HazardousObject } from "../../../types/api.types";
import { HazardousObjectCard } from "./HazardousObjectCard";

interface HazardousObjectMarkerProps {
  isSelected: boolean;
  onClick: () => void;
  hazardousObject: HazardousObject;
  badgeCount: number;
}

export const HazardousObjectMarker: React.FC<HazardousObjectMarkerProps> = ({
  isSelected,
  onClick,
  hazardousObject,
  badgeCount,
}) => {
  // Both tiers share one colour: the tiers are not comparable, so ranking them visually would mislead.
  const icon = useMemo(
    () => (
      <WarningAmberOutlinedIcon
        style={{ color: colors.white, fontSize: "18px" }}
      />
    ),
    []
  );

  return (
    <ComparableMarker
      isSelected={isSelected}
      markerProps={{
        lat: hazardousObject.lat,
        lng: hazardousObject.lng,
        backgroundColor: colors.orange,
        customIcon: icon,
        onClick,
        badgeCount,
      }}
    >
      <div
        style={{
          backgroundColor: colors.white,
          padding: "10px",
          borderRadius: "10px",
          width: "350px",
        }}
      >
        <HazardousObjectCard hazardousObject={hazardousObject} />
      </div>
    </ComparableMarker>
  );
};
